<div class="filter">
  <dmb-base-input
    class="filter-input"
    [value]="filterVal()"
    (valueChange)="filterVal.set($event)"
    [placeholder]="placeholder() ?? null">
    <svg-icon prefix icon="icon_search" class="flex"></svg-icon>
    @if (filterVal()) {
      <button mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <svg-icon icon="icon_close"></svg-icon>
      </button>
    }
  </dmb-base-input>
  <div class="filter-list">
    @if (allLabels()) {
      <div class="filter-item" [class.selected]="selected() === 'all'" (click)="selectAll()">
        <span i18n="@@switch.label.select.all">Select all</span>
      </div>
    }
    @for (item of filteredItems(); track item; let i = $index) {
      <div
        class="filter-item"
        (click)="selectItem(item)"
        [class.selected]="selected() === item"
        [class.first]="item['level'] === 1"
        [class.second]="item['level'] === 2"
        [class.third]="item['level'] === 3">
        <span [title]="item.name">{{ item.name }}</span>
      </div>
    }
    @if (filteredItems().length <= 0) {
      <div i18n="@@switch.label.notFound">No results found.</div>
    }
  </div>

  <div class="filter-buttons">
    <dmb-button type="button" variant="secondary" (buttonClick)="cancel()" i18n="@@Common.button.cancel"
      >Cancel</dmb-button
    >
    <dmb-button type="button" [disabled]="!hasSelection()" (buttonClick)="choose()" i18n="@@Common.button.choose"
      >Choose</dmb-button
    >
  </div>
</div>
